import type { ThemeOptions } from "@mui/material/styles";
import colors from "./palette.json";


export default {
	size: {
		header: {
			height: { out: 0 }
		}
	},
	palette: {
		mode: "dark",
		background: {
			paper: "linear-gradient(180deg, #06060D 0%, #2C2E69 100%)",
			header: "rgba(0, 0, 0, 0.60)",
			dark: "#ffffff1a",
			form: "#2c2e69"
		},
		text: {
			primary: colors.white,
			secondary: "#d4a4ff",
			disabled: colors.grey["500"],
			black: colors.black
		},
		primary: {
			main: "#fff",
			light: "rgb(255, 255, 255)",
			dark: "rgb(178, 178, 178)",
			contrastText: "rgba(0, 0, 0, 0.87)"
		},
		accordion: {
			icon: colors.grey["450"]
		},
		modal: {
			text: {
				light: colors.white,
				dark: colors.black
			},
			close: {
				light: colors.grey["800"],
				dark: colors.white
			}
		},
		article: {
			shadow: "rgba(252, 78, 15, 0.36)"
		},
		logo: {
			lite: "#ffffff38"
		}
	},
	components: {
		MuiDialog: {
			styleOverrides: {
				paper: {
					background: "linear-gradient(180deg, #06060D 0%, #2C2E69 100%)"

				}
			}
		}
	}
} as ThemeOptions;